import { ReferralCard } from 'src/features/home-page/components/ReferralCard/ReferralCard';

export const ReferralCardSlice = () => (
  <div className="container flex justify-center">
    <ReferralCard />
  </div>
);
